export default __webpack_public_path__ + "static/media/2017-IMcover.d20ff383.jpg";